import type { ImportStep } from "../types";

// The Import wizard is always a fixed 4-step journey regardless of which import
// mode (file / manual / agreements) the user picks. Labels live under import.steps.*.
export type WizardStepKey = "merchant" | "mode" | "data" | "result";

export interface WizardStepDef {
  key: WizardStepKey;
  labelKey: string; // i18n key under import.steps.*
}

export const WIZARD_STEPS: readonly WizardStepDef[] = [
  { key: "merchant", labelKey: "import.steps.merchant" },
  { key: "mode", labelKey: "import.steps.mode" },
  { key: "data", labelKey: "import.steps.data" },
  { key: "result", labelKey: "import.steps.result" },
] as const;

// Map the orchestrator's fine-grained ImportStep (+ whether a commit result is
// showing) onto the 4-step wizard index. File / manual / agreements all live in
// the "data" step until a result lands; manual mode never produces a result
// screen, so it stays on index 2.
export function wizardActiveIndex(step: ImportStep, hasResult: boolean): number {
  if (step === "merchant") return 0;
  if (step === "mode") return 1;
  return hasResult ? 3 : 2;
}
